<template>
  <div class="sm-upload-scan">
    <div 
      v-if="preview"
      class="sm-upload-scan__result"
    >
      <img :src="preview" />
      <a
        href="#"
        class="sm-upload-scan__result-delete"
        @click.prevent="deleteUpload"
      ></a>
    </div>
    <div
      v-else
      class="sm-upload-scan__main"
      @dragenter="dragEnter = true"
      @dragleave="dragEnter = false"
      @dragover.prevent
      @drop="handleDrop"
      @click="$refs[name].click()"
    >
      <template v-if="!dragEnter">
        <div class="sm-upload-scan__main-icon">
          <include-svg :name="'icon-upload-document'" />
        </div>
        <p>
          <span>Drag and drop shipping label image, or </span>
          <a
            href="#"
            class="sm-link"
            @click.prevent
          >upload</a>
        </p>
        <span class="sm-small">{{typesText}}</span>
        <input 
          :ref="name"
          hidden 
          type="file" 
          :accept="acceptTypes"
          :name="name" 
          @change="uploadFile" 
        />
      </template>
      <div v-else>Drop file here...</div>
    </div>
  </div>
</template>

<script>
import {IsRightFileType} from '@/utils/general-data';
import MimeTypes from '@/settings/mime-types';
import heic2any from 'heic2any';

export default {
  name: 'upload-scan',
  props: {
    name: {
      type: String,
      default: 'input'
    },
    types: {
      type: Array,
      default: () => []
    },
    typesText: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      status: 'new', // values: new, upload, error
      file: null,
      preview: null,
      maxFileWeight: 25165824,
      acceptTypes: '',
      dragEnter: false
    };
  },
  created() {
    if (this.types.length) {
      let typesArr = [];
      this.types.forEach(type => typesArr = [...typesArr, MimeTypes[type].join()]);
      this.acceptTypes = typesArr.join();
    }
  },
  methods: {
    isRightFileType: IsRightFileType,
    uploadFile(e) {
      if (e.target.files.length === 0) 
        return false;

      const target = e.target;
      this.file = target.files[0];

      this.handleUpload();
    },
    async handleUpload() {
      const fileExtension = this.file.name.substr(-4).toLowerCase()

      if (this.isRightFileType(this.file, this.types) || ['heic' ,'heif'].includes(fileExtension)) {
        this.status = 'upload';
        this.errors.remove(this.name);
        // this.$emit('upload', this.file);
       
        // this.preview = this.createPoster();

        if (fileExtension === 'heic' || fileExtension === 'heif') {
          try {
            const blob = await heic2any({ blob: this.file });
            const convertedUrl = URL.createObjectURL(blob);
            this.preview = convertedUrl;
            this.$emit('upload', blob); // Emit the converted blob instead of the original file
          } catch (error) {
            console.error('Error converting HEIC image:', error);
            this.status = 'error';
          }
        } else {
          // For other supported file types, directly emit the original file
          this.$emit('upload', this.file);
          this.preview = this.createPoster();
        }
      } else {
        this.status = 'error';
      }
    },
    deleteUpload(e) {
      this.$emit('delete');
      this.status = 'new';
      this.file = null;
      this.preview = null;

      e.stopPropagation();
    },
    createPoster() {
      if (!this.file || this.file.size > this.maxFileWeight) 
        return false;

      return URL.createObjectURL(this.file);
    },
    handleDrop(e) {
      e.preventDefault();
      this.dragEnter = false;

      if (e.dataTransfer.files.length === 0) 
        return false;

      this.file = e.dataTransfer.files[0];

      this.handleUpload();
    },
  }
}
</script>
